import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';


import { BillingTask } from '../../../../shared/models/billingTask.model';



import { MysqlService } from './../../../../services/mysql.service';

import { DatePipe } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map} from 'rxjs';


import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { CostTask } from './../../../../shared/models/costTask.model';
@Component({
  selector: 'app-edit-cost-task-widget',
  templateUrl: './edit-cost-task-widget.component.html',
  styleUrls: ['./edit-cost-task-widget.component.css']
})
export class EditCostTaskWidgetComponent implements OnInit {


       // setup as observable?
       @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'side'; // side | abstract | full

  model: CostTask;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  get_latest_document_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  get_latest_type_id: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  myob_account_codes: any;
  myob_tax_codes: any;
  brand_types: any;

 cost_task_id: number;
  cost_task: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) {




 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   }


     // check for changes. to load data.
     ngOnChanges(changes) {

      if (changes.item_id) {
        // deal with asynchronous Observable result
    this.cost_task_id = changes.item_id.currentValue;
    this.model = new CostTask();
    this.getCostTask(this.cost_task_id);
    this.getMyobAccountCodes();
    this.getMyobTaxCodes();
    this.getJobTypes();
    this.getBrandTypes();


        // this.getJob(this.job_id);
      }
    }
  




  ngOnInit() {
    //     this.model = new BillingTask();
    // this.getBillingTask(this.billing_task_id);
    // this.getMyobAccountCodes();
    // this.getMyobTaxCodes();
    // this.getJobTypes();
    // this.getBrandTypes();

  }


  getCostTask(cost_task_id) {
    this._demoService.getCostTask(cost_task_id).subscribe(
       data => { this.cost_task = data;
        let res = data[0];
        // Run the job data queries.
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

            // getBillingTask(billing_task_id) {
            //   this._demoService.getBillingTask(billing_task_id).subscribe(
            //      data => { this.billing_task = data;
            //       let res = data[0];
            //       // Run the job data queries.
            //     },
            //      err => console.error(err),
            //      // () => console.log('done loading Trace Types')
            //    );
            //  }

  createJobType(model) {
    // console.log(model);
        this._demoService.createJobType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Job Type Added');
       };
 


createBillingTask(model) {
  this._demoService.createBillingTask(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
    },
    error => {
     return console.log(error);
    });
};



updateCostTask(model) {
  this._demoService.updateCostTask(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
      this.toastr.success('cost task updated');
    },
    error => {
      this.toastr.error('cost task update failed');
      console.log(error.error);
      // return Observable.throw(error);
    });
};



      // updateBillingTask(model) {
      //   this._demoService.updateBillingTask(model).subscribe(
      //     data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      //       this.closeParentModel.emit();
      //       this.toastr.success('billing task updated');
      //     },
      //     error => {
      //       this.toastr.error('billing task update failed');
      //       console.log(error.error);
      //       // return Observable.throw(error);
      //     });
      // };



getMyobAccountCodes() {
  this._demoService.getMyobAccountCodes().subscribe(
     data => { this.myob_account_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getMyobTaxCodes() {
  this._demoService.getMyobTaxCodes().subscribe(
     data => { this.myob_tax_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


}